module.exports = __webpack_public_path__ + "static/media/talking.433225fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/activities/talking.png
// module id = 1481
// module chunks = 31